/**
 * Broadcast input: each mounted pane registers a sink that writes straight to
 * its own PTY / SSH channel. The focused pane of a broadcasting tab fans its
 * keystrokes out through `broadcastFrom`. The AI tab never registers a sink
 * (it refuses typing), so it can never be a broadcast target.
 */
const sinks = new Map(); // paneId -> (data) => void

export function registerPaneSink(paneId, write) {
  sinks.set(paneId, write);
  return () => {
    if (sinks.get(paneId) === write) sinks.delete(paneId);
  };
}

/** Write `data` to every pane in `targets` except `fromPaneId`. */
export function broadcastFrom(fromPaneId, targets, data) {
  targets.forEach((id) => {
    if (id === fromPaneId) return;
    sinks.get(id)?.(data);
  });
}

export const __sinkCount = () => sinks.size;
